import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { buildUrl, ContentRoute,RouteSlotInput  } from '@caritas/ui';

import { buildMessages, redirectWithAdditionalState } from '../../utils/iframe';

export const mapFormEmbedBlock = (pageContext: SilverbackPageContext) =>
  function (
    input: BlockFormEmbedFragment,
  ): RouteSlotInput<typeof ContentRoute, 'body', 'formEmbed'> {
    return {
      key: 'formEmbed',
      input: () => [
        {
          url: buildUrl([
            process.env.GATSBY_DRUPAL_CLIENT_URL || 'http://localhost:8888',
            '/',
            pageContext.locale,
            'form',
            input.id,
          ]),
          anchor: input.anchor,
          buildMessages: buildMessages(false, {lastSubmittedWebform: input.id}),
          redirect: redirectWithAdditionalState({lastSubmittedWebform: input.id}),
        },
        200,
      ],
    };
  };
